import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import ReactDom from 'react-dom';

import Button from '../../Components/Button';

import styles from './style';
import { EditPart, TitlePart } from '../../Parts';

import * as arrayUtils from '../../utils/array';

class EditTemplate extends Component {
  // 初始化编辑参数（如果是编辑）
  static mergeList(array, obj) {
    if (!obj) {
      return;
    }
    arrayUtils.forEach(array, (item) => {
      if (item.items) {
        arrayUtils.forEach(item.items, (t) => {
          t.value = t[item.key];
        });
      } else {
        item.value = obj[item.key];
      }
    });
  }
  constructor() {
    super();

    this.save = this.save.bind(this);
  }
  save() {
    const { checkValid, getData } = this.editPart;
    if (checkValid()) {
      const comdata = getData();
      this.props.save(comdata);
    }
  }

  render() {
    const { editItemList, valid, titlepart, respData } = this.props;
    EditTemplate.mergeList(editItemList, respData);

    return (
      <div>
        <TitlePart titlepart={titlepart} />
        <EditPart
          editItemList={editItemList}
          respData={respData}
          valid={valid}
          ref={(ref) => {
            this.editPart = ref;
          }}
        />
        <div
          style={styles.container}
        >
          <span style={styles.text} />
          <Button text={'保存'} type={['primary']} onClick={this.save} />
        </div>
      </div>
    );
  }
}

EditTemplate.propTypes = {
  editItemList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  valid: PropTypes.arrayOf(PropTypes.shape()),
  save: PropTypes.func,
  titlepart: PropTypes.shape(),
  respData: PropTypes.shape(),
};

EditTemplate.defaultProps = {
  valid: [],
  save: () => {},
  titlepart: {},
  respData: {}
};

const render = function (props) {
  ReactDom.render(
    <EditTemplate
      {...props}
    />,
    document.getElementById('root')
  );
};


export default function renderEdit(props) {
  render(props);
}



// WEBPACK FOOTER //
// ./src/Templates/EditTemplate/index.js